export default "__VITE_ASSET__DcxoBdhQ__"